import { render } from "./CotizacionApp.vue?vue&type=template&id=4af6d97e&scoped=true"
import script from "./CotizacionApp.vue?vue&type=script&lang=js"
export * from "./CotizacionApp.vue?vue&type=script&lang=js"

import "./CotizacionApp.vue?vue&type=style&index=0&id=4af6d97e&scoped=true&lang=css"

import exportComponent from "/var/www/html/AxumWebPage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4af6d97e"]])

export default __exports__